import { generatePath } from 'react-router-dom';

export const smsVoiceNumberPaths = {
  list: '/sms-voice-numbers',
  view: '/sms-voice-numbers/view/:phoneNumber',
  usageSummary: '/sms-voice-numbers/usage-summary',
  issues: '/sms-voice-numbers/issues',
} as const;

export const smsVoiceNumberViewPath = (phoneNumber: string): string =>
  generatePath(smsVoiceNumberPaths.view, { phoneNumber });
